import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Button from "../../button/Button"
import Wysiwyg from "../../Wysiwyg"

interface IComplexTextBlock {
  backgroundColor: string
  blockAlignment: "left" | "center" | "right"
  backgroundImage: any
  button: any
  formattingOption: "fullWidth" | "siteWidth"
  image: any
  subHeadline: string
  headline: string
  wysiwyg: string
}

const ComplexTextBlock = ({
  backgroundColor,
  blockAlignment,
  backgroundImage,
  formattingOption,
  button = "",
  subHeadline,
  headline,
  wysiwyg,
}: IComplexTextBlock) => {
  const bgImage =
    backgroundImage?.gatsbyImage && getImage(backgroundImage.gatsbyImage)
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={
        formattingOption === "fullWidth"
          ? "relative mx-auto  max-w-full pt-[20px] "
          : "relative  mx-auto max-w-7xl  "
      }
    >
      {bgImage && (
        <GatsbyImage
          image={bgImage}
          alt={backgroundImage?.altText ? backgroundImage?.altText : ""}
          className="absolute top-0 left-0 z-0 h-full w-full rounded object-cover object-bottom"
        />
      )}

      <div
        className={
          blockAlignment === "left"
            ? `z-10 flex flex-col p-[15px]  text-left`
            : blockAlignment === "right"
            ? `z-10 mx-auto flex flex-col p-[15px] text-right`
            : ` z-10 mx-auto flex flex-col p-[15px] text-center`
        }
      >
        {headline && (
          <h2 className="z-10 pb-[10px] text-darkBlue" id={headline}>
            {headline}
          </h2>
        )}
        {subHeadline && (
          <p className="text-subheadline2 z-10 mb-[15px] font-neusa text-[24px] font-normal text-darkBlue">
            {subHeadline}
          </p>
        )}

        {wysiwyg && (
          <Wysiwyg blockAlignment={blockAlignment} content={wysiwyg} />
        )}

        {button && (
          <div
            className={
              blockAlignment === "left"
                ? `z-10 mt-[15px] flex justify-start`
                : blockAlignment === "right"
                ? `z-10 mt-[15px] flex justify-end `
                : `z-10 mt-[15px] flex justify-center`
            }
          >
            <Button
              className="relative mx-auto  mt-[20px] block sm:hidden"
              variant="secondary"
              to={button.url}
              size="medium"
            >
              {button.title}
            </Button>
            <Button
              className="mt-[20px] ml-[12px] hidden sm:block "
              variant="secondary"
              to={button.url}
              size="large"
            >
              {button.title}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ComplexTextBlock

export const fragment = graphql`
  fragment ComplexTextBlock on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_ComplexTextBlock {
      backgroundColor
      blockAlignment
      wysiwyg
      backgroundImage {
        gatsbyImage(width: 1226, height: 517, formats: [AUTO, WEBP])
      }
      formattingOption
      button {
        title
        url
      }
      headline
      subHeadline
    }
  }
`
